import axios, { Method } from "axios";
import { toast } from "sonner";
import {
  getTokenFromLocalStore,
  checkTokenExpiry,
  saveTokenToLocalStore,
  clearAll,
} from "utils/localstore";
import { refreshToken } from "./auth";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

export const refreshAccessToken = async () => {
  try {
    const refreshTkn = getTokenFromLocalStore<string>("refresh_token");
    if (!refreshTkn) {
      throw new Error("No refresh token found");
    }

    const response: any = await refreshToken(refreshTkn);
    if (!response || !response.access || !response.refresh) {
      throw new Error("Invalid token response");
    }

    const { access, refresh } = response;

    saveTokenToLocalStore("access_token", access);
    saveTokenToLocalStore("refresh_token", refresh);

    return access;
  } catch (error) {
    console.error("Error refreshing access token:", error);
    toast.error("Error refreshing access token. Please login again.");
    clearAll(true);
    throw error;
  }
};

const apiService = async (
  url: string,
  method: Method,
  requestData?: any,
  protectedRoute: boolean = false,
  headers: any = {
    "Content-Type": "application/json",
  },
  baseURL: string = process.env.REACT_APP_BASE_URL || "",
  params?: any,
  responseType: "json" | "blob" = "json"
) => {
  let token = getTokenFromLocalStore<string>("access_token") || "";
  if (protectedRoute) {
    if (checkTokenExpiry(token)) {
      try {
        token = await refreshAccessToken();
      } catch (error) {
        return;
      }
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    axios.defaults.headers.common["Authorization"] = "";
  }

  try {
    const { data } = await axios({
      method,
      url,
      data: requestData,
      baseURL,
      headers,
      params,
      responseType,
    });
    return data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
export default apiService;
